export { LoginProvider } from './login-provider';

export { GoogleLoginProvider } from './google-login-provider';
export { FacebookLoginProvider } from './facebook-login-provider';
export { LinkedInLoginProvider } from './linkedIn-login-provider';
